export default __webpack_public_path__ + "static/media/ScatteredTwo.d5bc89ad.JPG";